import axios from 'axios'
import { DESBLOQUEAR_POLTRONA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function desbloquearPoltrona (parametros) {
  const url = `${URL}/poltronas/desbloquear`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: DESBLOQUEAR_POLTRONA,
        payload: response
      })
  );
}
